import React from 'react';

const PRIORITY_STYLES = {
  low: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40',
  medium: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
  high: 'bg-orange-500/20 text-orange-300 border-orange-500/40',
  critical: 'bg-red-500/20 text-red-300 border-red-500/40',
};

function PriorityPill({ priority = 'medium' }) {
  const normalizedPriority = String(priority || '').toLowerCase();
  const style =
    PRIORITY_STYLES[normalizedPriority] || 'bg-gray-600/20 text-gray-300 border-gray-600/40';

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-wide ${style}`}>
      {priority}
    </span>
  );
}

export default PriorityPill;
